import { getCategories, createCategories, updateCategories, activateCategories, deactivateCategories } from '../../../../actions/CategoriesActions';
import { CREATE_CATEGORIES, UPDATE_CATEGORIES, GET_ERRORS, ACTIVATE_CATEGORIES, DEACTIVATE_CATEGORIES } from '../../../../actions/types';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import BootstrapTable from 'react-bootstrap-table-next';
import DialogTitle from '@material-ui/core/DialogTitle';
import LoadingOverlay from 'react-loading-overlay';
import 'react-widgets/dist/css/react-widgets.css';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Icon from '@material-ui/core/Icon';
import React, { Component } from 'react';
import DetailModal from './DetailModal';
import { connect } from 'react-redux';
import '../MainContent.scss';
import './Categories.scss';

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class CategoriesContent extends Component {
	///---------------------------------------INIT-------------------------------------

	state = {
		activeLoader:         true,
		showSnackBar:         false,
		textSnackBar:         '',
		severitySnackBar:     'success',
		openDetailModal:      false,
		categories:           [],
		showDeactivateDialog: false,
		selectedId:           0,
		data: {
			_id:           null,
			name:          null,
			image_url:     null,
			subcategories: [],
			is_active:     null,
		},
	};

	constructor(props) {
		super(props);
		this.handleCloseDeactivateDialog = this.handleCloseDeactivateDialog.bind(this);
		this.onPressCancel               = this.onPressCancel.bind(this);
		this.onPressDelete               = this.onPressDelete.bind(this);
		this.onDeactivate                = this.onDeactivate.bind(this);
		this.handleClose                 = this.handleClose.bind(this);
		this.onActivate                  = this.onActivate.bind(this);
		this.openModal                   = this.openModal.bind(this);
		this.onChange                    = this.onChange.bind(this);
		this.onSave                      = this.onSave.bind(this);
	}

	componentDidMount() {
		this.props.getCategories();
	}

	componentDidUpdate(prevProps) {
		if (this.state.categories !== this.props.categories || this.props.categories.length === 0) {
			this.setState({
				activeLoader: false,
				categories:   this.props.categories,
			});
		} else if (this.props.actionType === ACTIVATE_CATEGORIES && prevProps.actionType !== ACTIVATE_CATEGORIES) {
			this.props.getCategories();
			this.setState({
				activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     'Categoria activada exitosamente.',
				severitySnackBar: 'success',
			});
		} else if (this.props.actionType === DEACTIVATE_CATEGORIES && prevProps.actionType !== DEACTIVATE_CATEGORIES) {
			this.props.getCategories();
			this.setState({
				activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     'Categoria desactivada exitosamente.',
				severitySnackBar: 'success',
			});
		} else if (this.props.actionType === UPDATE_CATEGORIES && prevProps.actionType !== UPDATE_CATEGORIES) {
			this.props.getCategories();
			this.setState({
				activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     'Categoria actualizada exitosamente.',
				severitySnackBar: 'success',
			});
		} else if (this.props.actionType === CREATE_CATEGORIES && prevProps.actionType !== CREATE_CATEGORIES) {
			this.props.getCategories();
			this.setState({
				activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     'Categoria creada exitosamente.',
				severitySnackBar: 'success',
			});
		} else if (this.props.actionType === GET_ERRORS && prevProps.actionType !== GET_ERRORS) {
			this.setState({
				activeLoader:     false,
				showSnackBar:     true,
				textSnackBar:     this.props.error,
				severitySnackBar: 'error',
			});
		}
	}

	///---------------------------------------EVENTS-------------------------------------

	handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({
			showSnackBar: false,
		});
	};

	handleCloseDeactivateDialog = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({
			showDeactivateDialog: false,
		});
	};

	onChange = (e) => this.setState({ [e.target.name]: e.target.value });

	onPressCancel() {
		this.setState({
			openDetailModal: false,
			data: {
				_id:           null,
				name:          null,
				image_url:     null,
				subcategories: [],
				is_active:     null,
			},
		});
	}

	onSave(data) {
		if (data._id !== null) this.onUpdate(data);
		else this.handleOk(data);
	}

	async onUpdate(data) {
		let img_b64       = null;
		let extension     = null;
		let subcategories = [];
		if (data.newImage) {
			img_b64   = data.file;
			extension = data.extension;
		}
		if (data.subcategories.length > 0)
			subcategories = data.subcategories.map((subcategory) => subcategory._id);
			this.props.updateCategories(
				data._id,
				data.name,
				img_b64,
				extension,
				subcategories
			);
		this.setState({
			activeLoader:    true,
			openDetailModal: false,
			data: {
				_id:           null,
				name:          null,
				image_url:     null,
				subcategories: [],
				is_active:     null,
			},
		});
	}

	async handleOk(data) {
		let img_b64       = null;
		let extension     = null;
		let subcategories = [];
		if (data.newImage) {
			img_b64   = data.file;
			extension = data.extension;
		}
		if (data.subcategories.length > 0)
			subcategories = data.subcategories.map((subcategory) => subcategory._id);
		this.props.createCategories(data.name, img_b64, extension, subcategories);
		this.setState({
			activeLoader:    true,
			openDetailModal: false,
			data: {
				_id:           null,
				name:          null,
				image_url:     null,
				subcategories: [],
				is_active:     null,
			},
		});
	}

	onPressDelete(id) {
		this.setState({
			showDeactivateDialog: true,
			selectedId:           id,
		});
	}

	onDeactivate() {
		this.setState({
			activeLoader:         true,
			openDetailModal:      false,
			showDeactivateDialog: false,
		});
		this.props.deactivateCategories(this.state.selectedId);
	}

	onActivate(id) {
		this.setState({
			activeLoader:    true,
			openDetailModal: false,
		});
		this.props.activateCategories(id);
	}

	openModal(row) {
		if (!row.dispatchConfig) {
			let data = {
				_id:           row._id,
				name:          row.name,
				image_url:     row.image_url,
				subcategories: row.subcategories.map((subcategory) => {
					return {
						_id:  subcategory._id,
						name: subcategory.name,
					};
				}),
				is_active:     row.is_active,
			};
			this.setState({
				openDetailModal: true,
				data:            data,
			});
		} else
			this.setState({
				openDetailModal: true,
				data: {
					_id:           null,
					name:          null,
					image_url:     null,
					subcategories: [],
					is_active:     null,
				},
			});
	}

	///---------------------------------------VIEW-------------------------------------

	renderTable(categories) {
		const columns = [
			{
				dataField: 'image_url',
				text:      'Imagen',
				formatter: (cell) => {
					return <img src={cell} width="30%" alt={'Sin imagen'} />;
				},
			},
			{
				dataField: 'name',
				text:      'Nombre',
				headerStyle: () => {
					return { width: '30%' };
				},
			},
			{
				dataField: 'subcategories',
				text:      'Subcategorías',
				headerStyle: () => {
					return { width: '40%' };
				},
				formatter: (cell) => {
					if (cell)
						return (
							<>
								{cell.map((label, index) => (
									<li key={index}>{label.name}</li>
								))}
							</>
						);
					else return '';
				},
			},
			{
				dataField: 'is_active',
				text:      'Estatus',
				headerStyle: () => {
					return { width: '10%' };
				},
				formatter: (cell) => (cell ? 'Activa' : 'Inactiva'),
			},
		];
		const rowEvents = {
			onClick: (e, row, rowIndex) => {
				this.openModal(row);
			},
		};

		return (
			<center>
				<div className="toolbar end">
					<Button
						style={{
							height: "10%",
							backgroundColor: "#2ecc71",
							padding: "0.8rem 0.8rem",
							fontSize: "0.7rem",
						}}
						variant="contained"
						color="primary"
						startIcon={<Icon>add</Icon>}
						onClick={this.openModal}
					>
						Agregar
					</Button>
				</div>
				<div style={{ textAlign: "left", height: "60vh", overflow: "auto", width: "100%", marginTop: "2vh" }}>
					{
						<BootstrapTable
							keyField="_id"
							key="8908290138209"
							striped
							hover
							condensed
							rowEvents={rowEvents}
							data={categories}
							headerWrapperClasses="title-table"
							rowClasses="custom-row-table"
							columns={columns}
						/>
					}
				</div>
			</center>
		);
	}

	render() {
		return (
			<div style={{ marginTop: ".1vh" }}>
				{
					<DetailModal
						isVisible={this.state.openDetailModal}
						data={this.state.data}
						subcategoriesToSelect={this.props.subcategoriesToSelect}
						onSave={this.onSave}
						onPressCancel={this.onPressCancel}
						onPressDelete={this.onPressDelete}
						onPressActivate={this.onActivate}
						type="category"
					/>
				}
				{this.state.openDetailModal === false && this.renderTable(this.state.categories)}

				{
					<LoadingOverlay
						active={this.state.activeLoader}
						isVisible={this.state.activeLoader}
						spinner
						text="Esto puede tardar unos minutos"
						styles={{
							wrapper: {
								width: this.state.activeLoader ? '100%' : '0%',
								height: this.state.activeLoader ? '100%' : '0%',
								overflow: 'hidden',
							},
							overlay: (base) => ({
								...base,
								background: 'rgba(10, 10, 10, 0.7)',
							}),
						}}
					></LoadingOverlay>
				}
				{
					<Dialog
						open={this.state.showDeactivateDialog}
						onClose={this.handleCloseDeactivateDialog}
						aria-labelledby="alert-dialog-title"
						aria-describedby="alert-dialog-description"
					>
						<DialogTitle id="alert-dialog-title">{"Desactivar categoria"}</DialogTitle>
						<DialogContent>
							<DialogContentText id="alert-dialog-description">¿Seguro que deseas desactivar la categoria?</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Button onClick={this.handleCloseDeactivateDialog}color="secondary">Cancelar</Button>
							<Button onClick={this.onDeactivate} color="primary" autoFocus>Desactivar</Button>
						</DialogActions>
					</Dialog>
				}
				{
					<Snackbar open={this.state.showSnackBar} autoHideDuration={6000} onClose={this.handleClose}>
						<Alert onClose={this.handleClose} severity={this.state.severitySnackBar}>
							{this.state.textSnackBar}
						</Alert>
					</Snackbar>
				}
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	error:      state.category_reducer.error,
	categories: state.category_reducer.categories,
	actionType: state.category_reducer.actionType,
	success:    state.success,
});

export default connect(mapStateToProps, {
	getCategories,
	createCategories,
	updateCategories,
	deactivateCategories,
	activateCategories,
})(CategoriesContent);
